import ContractInfoSlaModal from "./ContractInfoSlaModal";

export default ContractInfoSlaModal;
